import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';
import AccountData from '../../assets/jsondata/account-service-package.json';

@Injectable({
  providedIn: 'root'
})
export class AccountPackageService {
  servicePackage: any = AccountData.data;

  getServicePackage() {
    return this.servicePackage;
  }

  setPackageRatePlan(servicePackages) {
    if(isNullOrUndefined(servicePackages) || servicePackages.length == 0) return new Array();

    servicePackages.forEach(servicePackage => {
      let activeRatePlan = servicePackage.packageRatePlans.find(element => (element.isActive && (isNullOrUndefined(element.appliedTill) || new Date(element.appliedTill * 1000) > new Date())));
      if(!isNullOrUndefined(activeRatePlan)) {
        servicePackage['packageRatePlan'] = activeRatePlan;
      } else {
        servicePackage['packageRatePlan'] = servicePackage.packageRatePlans[0];
      }
    });

    servicePackages.forEach(servicePackage => {
      let activeRatePlan = servicePackage.consolidatedRatePlans.find(element => (element.isActive && (isNullOrUndefined(element.appliedTill) || new Date(element.appliedTill * 1000) > new Date())));
      if(!isNullOrUndefined(activeRatePlan)) {
        servicePackage['consolidatedRatePlan'] = activeRatePlan;
      } else {
        servicePackage['consolidatedRatePlan'] = servicePackage.consolidatedRatePlans[0];
      }
    });
    
    return servicePackages;
  }

  showPackageRatePlan(servicePackageData: any): boolean {
    if(servicePackageData.packageRatePlan.packageType) {
      if (servicePackageData.packageRatePlan.packageType != 'TRIAL' || 
          (servicePackageData.packageRatePlan.packageType == 'TRIAL' && 
            servicePackageData.packageRatePlan.trialPackage.postTrial != 'CANCEL_PACKAGE')) {
        return true;
      }
    }
    return false;
  }
}
